import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { UsersService, WsService } from '@app/shared';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { User } from '@app/users/user.interface';
import { UsersDataService } from '@app/users/users-data.service';

@Component({
  selector: 'app-delete-user',
  templateUrl: './delete-user.component.html',
  styleUrls: ['./delete-user.component.scss']
})
export class DeleteUserComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,
    private userService: UsersDataService,
    public dialogRef: MatDialogRef<DeleteUserComponent>,
    @Inject(MAT_DIALOG_DATA) public user: User,
    private ws: WsService) { }

  ngOnInit() {
  }

  delete() {
    this.userService.deleteUser(this.user.id).subscribe(res => {
      if (!res.error) { 
        //this.userService.getUsersByScrooll(this.userService.currentPage);
        this.userService.emmitDeleteUser(this.user.id);
        this.dialogRef.close(); }
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/users/delete-user/delete-user.component.ts